



































































































































































import { defineComponent, ref, onMounted } from '@vue/composition-api'
import {
  mdiCancel,
  mdiDotsVertical,
  mdiFilterVariantMinus,
  mdiPencilOutline,
  mdiPlus,
  mdiViewListOutline,
  mdiContentCopy,
} from '@mdi/js'
import useSweetAlert from '@core/plugins/sweetalert'
import { useRouter } from '@core/utils'

// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import PaginationFooter from '@shared/components/PaginationFooter.vue'

// Components
import RequisitoTramiteFiltro from '../components/RequisitoTramiteFiltro.vue'
import RequisitoTramiteEditarModal from '../components/RequisitoTramiteEditarModal.vue'

import { IResponseElement, RequisitoTramiteFiltroModel, RequisitoTramiteInterface, Pagination } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'

export default defineComponent({
  components: {
    PaginationSelect,
    PaginationFooter,
    RequisitoTramiteFiltro,
    RequisitoTramiteEditarModal,
  },
  setup() {
    const requisitos = ref<RequisitoTramiteInterface[]>(store.getters['requisitoTramite/requisitos'])
    const isFilterPanelActive = ref(false)
    const mostrarRequisitoTramiteEditarModal = ref(false)
    const filtro = ref(new RequisitoTramiteFiltroModel())
    const pagination = ref(new Pagination())
    const todoSeleccionado = ref(false)

    const { confirm, showMessage } = useSweetAlert()
    const { isLoading } = useAppConfig()
    const { router } = useRouter()

    onMounted(() => {
      filtro.value.limit = 50
      obtenerRequisitos(filtro.value)
    })

    const obtenerRequisitos = async (filter: RequisitoTramiteFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('requisitoTramite/obtenerRequisitos', params)

      if (ok) {
        requisitos.value = store.getters['requisitoTramite/requisitos']
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<RequisitoTramiteInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const editarRequisitoTramite = (requisitoTramite: RequisitoTramiteInterface) => {
      store.commit('requisitoTramite/cargarRequisito', requisitoTramite)
      mostrarRequisitoTramiteEditarModal.value = true
    }

    const cambiarEstadoRequisito = async (requisito: RequisitoTramiteInterface) => {
      const { value } = await confirm(`¿Está seguro de cambiar el estado del requisito?`, 'success')

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch(
          'requisitoTramite/cambiarEstadoRequisito',
          requisito.requisitoTramiteId,
        )

        if (ok) {
          showMessage('Éxito!', response.mensaje, 'success')
          obtenerRequisitos(filtro.value)
        }
        isLoading.value = false
      }
    }

    const requisitoTramiteOnClose = (actualizar: boolean) => {
      mostrarRequisitoTramiteEditarModal.value = false
      store.commit('requisitoTramite/limpiarRequisitoCombos')
      if (actualizar) {
        obtenerRequisitos(filtro.value)
      }
    }

    const seleccionarTodos = () => {
      requisitos.value = requisitos.value.map((requisito: RequisitoTramiteInterface) => {
        return {
          ...requisito,
          seleccionado: todoSeleccionado.value,
        }
      })
    }

    const seleccionar = () => {
      const requisitosSeleccionados = requisitos.value.filter(
        (requisitos: RequisitoTramiteInterface) => requisitos.seleccionado === true,
      )
      todoSeleccionado.value = requisitosSeleccionados.length === requisitos.value.length
    }

    const copiarRequisitos = () => {
      const requisitosSeleccionados = requisitos.value
        .filter((requisito: RequisitoTramiteInterface) => requisito.seleccionado === true)
        .filter(
          (requisito: RequisitoTramiteInterface, index: number, registros: RequisitoTramiteInterface[]) =>
            index === registros.findIndex(registro => registro.requisitoCodigo === requisito.requisitoCodigo),
        )

      if (requisitosSeleccionados.length === 0) {
        showMessage('Seleccionar requisitos', 'Debe seleccionar al menos un requisito', 'warning')

        return
      }

      store.commit('requisitoTramite/cargarRequisitosCopiados', requisitosSeleccionados)
      router?.push({ name: 'requisito-tramite-nuevo' })
    }

    return {
      cambiarEstadoRequisito,
      editarRequisitoTramite,
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarRequisitoTramiteEditarModal,
      obtenerRequisitos,
      pagination,
      requisitos,
      requisitoTramiteOnClose,
      seleccionar,
      seleccionarTodos,
      todoSeleccionado,
      copiarRequisitos,
      icons: {
        mdiCancel,
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiPencilOutline,
        mdiPlus,
        mdiViewListOutline,
        mdiContentCopy,
      },
    }
  },
})
